import SupportAreaModal from './support-area-modal-container'
export default SupportAreaModal
